import styled from '@emotion/styled';
import type { StyledComponent } from '@emotion/styled';
import { color, text } from '@tokens';
import { shouldForwardProp } from '@utils/styledProps';
import type { TextProps } from './TextUtils';

const styledTextPropNames = ['as', 'textColor', 'textType'] as const;

/**
 * Helper for text content, to use typography tokens easily.
 *
 * {@link https://zeroheight.com/76c439891/p/0050ca-typography Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-text Code documentation}
 *
 * @example
 * <Text as="p" textType="body1">Some intro text.</Text>
 */
export const Text: StyledComponent<TextProps> = styled('span', {
  shouldForwardProp: shouldForwardProp(styledTextPropNames),
})<TextProps>`
  color: ${({ textColor }) =>
    textColor === 'inherited' ? 'inherit' : color[textColor]};
  ${({ textType }) => text(textType)};
`;

Text.defaultProps = {
  textColor: 'text_default',
  textType: 'body2',
};
